<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col">
            <h3 class="page-title">Công Việc Đã Lưu Trữ</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Lưu trữ</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card filter-card">
        <div
          class="card-header filter-card-header"
          data-toggle="collapse"
          href="#filter_inputs"
          role="button"
          aria-expanded="true"
          aria-controls="filter_inputs"
        >
          <h5 class="card-title mb-0">Bộ lọc & Tìm kiếm</h5>
          <i class="fa fa-chevron-down collapse-icon"></i>
        </div>
        <div class="card-body collapse" id="filter_inputs">
          <div class="row">
            <div class="col-md-4 col-sm-6">
              <div class="form-group">
                <label>Tên công việc</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nhập tiêu đề..."
                  v-model.trim="filters.tieuDe"
                  @keyup.enter="applyFilter"
                />
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="form-group">
                <label>Không gian làm việc</label>
                <select class="form-control" v-model="filters.workspaceId">
                  <option :value="null">Tất cả</option>
                  <option v-for="ws in workspaces" :key="ws.id" :value="ws.id">
                    {{ ws.tieuDe }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="form-group">
                <label>Cột công việc</label>
                <select
                  class="form-control"
                  v-model="filters.columnId"
                  :disabled="!filters.workspaceId"
                >
                  <option :value="null">Tất cả cột</option>
                  <option v-for="col in columns" :key="col.id" :value="col.id">
                    {{ col.tenCot }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="form-group">
                <label>Độ ưu tiên</label>
                <select class="form-control" v-model="filters.doUuTien">
                  <option :value="null">Tất cả</option>
                  <option
                    v-for="p in PRIORITY_OPTIONS"
                    :key="p.key"
                    :value="p.key"
                  >
                    {{ p.text }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="form-group">
                <label>Người tạo</label>
                <vue-multiselect
                  v-model="selectedCreator"
                  :options="users"
                  placeholder="Chọn người tạo"
                  label="hoTen"
                  track-by="idNguoiDung"
                  :allow-empty="true"
                  deselect-label="Nhấn Enter để bỏ chọn"
                  select-label="Nhấn Enter để chọn"
                  selected-label="Đã chọn"
                />
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="form-group">
                <label>Người thực hiện</label>
                <vue-multiselect
                  v-model="selectedAssignedUser"
                  :options="users"
                  placeholder="Chọn người thực hiện"
                  label="hoTen"
                  track-by="idNguoiDung"
                  :allow-empty="true"
                  deselect-label="Nhấn Enter để bỏ chọn"
                  select-label="Nhấn Enter để chọn"
                  selected-label="Đã chọn"
                />
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="form-group">
                <label>Độ khó</label>
                <select class="form-control" v-model="filters.doKho">
                  <option :value="null">Tất cả</option>
                  <option value="EASY">Dễ</option>
                  <option value="MEDIUM">Vừa</option>
                  <option value="HARD">Khó</option>
                </select>
              </div>
            </div>
            <div class="col-md-4 col-sm-6">
              <div class="form-group">
                <label>Thẻ Tag</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="filters.tags"
                  @keyup.enter="applyFilter"
                  placeholder="Tìm theo thẻ..."
                />
              </div>
            </div>
          </div>
          <hr class="mt-1 mb-3" />
          <div class="row">
            <div class="col-12 d-flex justify-content-end align-items-center">
              <div class="dropdown mr-2">
                <button
                  class="btn btn-light dropdown-toggle"
                  data-toggle="dropdown"
                >
                  <i class="fa fa-columns"></i> Hiển thị
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right p-3"
                  style="min-width: 250px"
                >
                  <div
                    class="form-check mb-2"
                    v-for="f in FIELD_DEFS"
                    :key="f.key"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'field-' + f.key"
                      :value="f.key"
                      v-model="selectedFieldList"
                    />
                    <label class="form-check-label" :for="'field-' + f.key">{{
                      f.label
                    }}</label>
                  </div>
                </div>
              </div>
              <button
                class="btn btn-outline-secondary mr-2"
                @click="resetFilters"
              >
                <i class="fa fa-refresh"></i> Làm mới
              </button>
              <button
                class="btn btn-primary"
                @click="applyFilter"
                :disabled="loading"
              >
                <i class="fa fa-filter"></i> Lọc dữ liệu
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card shadow-sm border-0">
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-hover table-vcenter mb-0">
              <thead class="thead-light">
                <tr>
                  <th
                    v-for="col in VISIBLE_COLS"
                    :key="col.key"
                    :style="{ width: col.width || 'auto' }"
                  >
                    {{ col.label }}
                  </th>
                  <th class="text-right" style="width: 120px">Hành động</th>
                </tr>
              </thead>

              <tbody v-if="loading">
                <tr>
                  <td
                    :colspan="VISIBLE_COLS.length + 1"
                    class="text-center py-5"
                  >
                    <div class="spinner-border text-primary"></div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else-if="archivedTasks.length === 0">
                <tr>
                  <td
                    :colspan="VISIBLE_COLS.length + 1"
                    class="text-center text-muted py-5"
                  >
                    Không tìm thấy công việc nào.
                  </td>
                </tr>
              </tbody>

              <tbody v-else>
                <tr v-for="task in archivedTasks" :key="task.id">
                  <td
                    v-for="col in VISIBLE_COLS"
                    :key="col.key"
                    :style="
                      col.key === 'tieuDe'
                        ? { 'max-width': '400px', 'min-width': '250px' }
                        : {}
                    "
                  >
                    <template v-if="col.key === 'tieuDe'">
                      <a
                        href="#"
                        @click.prevent="openDetailModal(task)"
                        class="font-weight-bold d-block text-dark text-truncate"
                        :title="getValue(task, col.key)"
                        v-tooltip="getValue(task, col.key)"
                        >{{ getValue(task, col.key) }}</a
                      >
                      <small class="text-muted text-truncate d-block"
                        >{{ getValue(task, "workspace.tieuDe") }} /
                        {{ getValue(task, "column.tenCot") }}</small
                      >
                    </template>
                    <template v-else-if="col.key === 'nguoiTao.hoTen'">
                      <div class="d-flex align-items-center">
                        <img
                          :src="
                            task.nguoiTao?.avatarUrl ||
                            '/assets/img/profiles/avatar-02.jpg'
                          "
                          class="rounded-circle mr-2"
                          width="24"
                          height="24"
                          alt=""
                        />
                        <span>{{ getValue(task, col.key) }}</span>
                      </div>
                    </template>
                    <template v-else-if="col.key === 'assignedUsers'">
                      <div class="avatar-stack">
                        <img
                          v-for="user in (task.assignedUsers || []).slice(0, 3)"
                          :key="user.idNguoiDung"
                          :src="
                            user.avatarUrl ||
                            '/assets/img/profiles/avatar-02.jpg'
                          "
                          class="avatar avatar-xs rounded-circle"
                          v-tooltip="user.hoTen"
                        />
                        <span
                          v-if="(task.assignedUsers || []).length > 3"
                          class="avatar avatar-xs rounded-circle avatar-more"
                          >+{{ task.assignedUsers.length - 3 }}</span
                        >
                      </div>
                    </template>
                    <template v-else-if="col.key === 'doUuTien'">
                      <span
                        class="badge"
                        :class="getPriorityInfo(task.doUuTien).badgeClass"
                      >
                        <i
                          :class="getPriorityInfo(task.doUuTien).icon"
                          class="mr-1"
                        ></i>
                        {{ getPriorityInfo(task.doUuTien).text }}
                      </span>
                    </template>
                    <template v-else-if="col.key === 'doKho'">
                      <span
                        v-if="task.doKho"
                        class="badge"
                        :class="{
                          'badge-success': task.doKho === 'EASY',
                          'badge-warning': task.doKho === 'MEDIUM',
                          'badge-danger': task.doKho === 'HARD',
                        }"
                      >
                        {{
                          task.doKho === "EASY"
                            ? "Dễ"
                            : task.doKho === "MEDIUM"
                            ? "Vừa"
                            : "Khó"
                        }}
                      </span>
                      <span v-else class="text-muted">-</span>
                    </template>

                    <template v-else-if="col.key === 'tags'">
                      <div
                        v-if="
                          task.tags &&
                          typeof task.tags === 'string' &&
                          task.tags.length > 0
                        "
                      >
                        <span
                          v-for="(tag, index) in task.tags
                            .split(',')
                            .slice(0, 2)"
                          :key="index"
                          class="badge badge-light border mr-1"
                          style="font-weight: normal"
                        >
                          #{{ tag.trim() }}
                        </span>
                        <span
                          v-if="task.tags.split(',').length > 2"
                          class="badge badge-secondary"
                          v-tooltip="task.tags"
                        >
                          +{{ task.tags.split(",").length - 2 }}
                        </span>
                      </div>
                      <span v-else class="text-muted">-</span>
                    </template>
                    <template v-else>
                      <span>{{ getValue(task, col.key) }}</span>
                    </template>
                  </td>

                  <td class="text-right">
                    <button
                      class="btn btn-sm btn-outline-info mr-1"
                      v-tooltip="'Xem chi tiết'"
                      @click="openDetailModal(task)"
                    >
                      <i class="fa fa-eye"></i>
                    </button>
                    <!-- <button
                      class="btn btn-sm btn-outline-primary mr-1"
                      title="Khôi phục"
                      @click="handleRestoreTask(task.id)"
                    >
                      <i class="fa fa-undo"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-outline-danger"
                      title="Xóa vĩnh viễn"
                      @click="handleDeleteTask(task.id)"
                    >
                      <i class="fa fa-trash-o"></i>
                    </button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          v-if="totalPages > 1"
          class="card-footer bg-white d-flex justify-content-between align-items-center"
        >
          <small class="text-muted"
            >Trang {{ currentPage + 1 }} / {{ totalPages }} (Tổng số
            {{ totalElements }} công việc)</small
          >
          <nav>
            <ul class="pagination mb-0">
              <li class="page-item" :class="{ disabled: currentPage === 0 }">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="goToPage(currentPage - 1)"
                  >Trước</a
                >
              </li>
              <li
                class="page-item"
                v-for="page in visiblePages"
                :key="page"
                :class="{ active: currentPage === page - 1 }"
              >
                <a
                  v-if="page !== '...'"
                  class="page-link"
                  href="#"
                  @click.prevent="goToPage(page - 1)"
                  >{{ page }}</a
                >
                <span v-else class="page-link">...</span>
              </li>
              <li
                class="page-item"
                :class="{ disabled: currentPage === totalPages - 1 }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="goToPage(currentPage + 1)"
                  >Sau</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

  <ArchivedTaskDetailModal
    :show="isDetailModalVisible"
    :task="selectedTask"
    @close="closeDetailModal"
    @restore="handleRestoreFromModal"
    @delete="handleDeleteFromModal"
  />
</template>

<script setup>
import { ref, onMounted, watch, computed, reactive } from "vue";
import { useToast } from "vue-toastification";
import Swal from "sweetalert2"; // ✨ MỚI: Thư viện cho hộp thoại xác nhận
import ArchivedTaskDetailModal from "@/components/ArchivedTaskDetailModal.vue";

import taskService from "@/services/taskService";
import workspaceService from "@/services/workspaceService";
import workColumnService from "@/services/workColumnService";
import userService from "@/services/userService";

const toast = useToast();

const archivedTasks = ref([]);
const workspaces = ref([]);
const columns = ref([]);
const users = ref([]);

const isDetailModalVisible = ref(false);
const selectedTask = ref(null);
const selectedCreator = ref(null);
const selectedAssignedUser = ref(null);

const filters = reactive({
  tieuDe: "",
  doUuTien: null,
  workspaceId: null,
  columnId: null,
  creatorId: null,
  assignedUserId: null,
  doKho: null,
  tags: "",
});

// ✨ MỚI: Thêm thông tin icon và class cho từng độ ưu tiên
const PRIORITY_OPTIONS = [
  {
    key: "URGENT",
    text: "Khẩn cấp",
    icon: "fa fa-exclamation-circle",
    badgeClass: "badge-danger-soft",
  },
  {
    key: "HIGH",
    text: "Cao",
    icon: "fa fa-arrow-up",
    badgeClass: "badge-warning-soft",
  },
  {
    key: "MEDIUM",
    text: "Trung bình",
    icon: "fa fa-minus",
    badgeClass: "badge-primary-soft",
  },
  {
    key: "LOW",
    text: "Thấp",
    icon: "fa fa-arrow-down",
    badgeClass: "badge-secondary-soft",
  },
];

const getPriorityInfo = (key) => {
  return PRIORITY_OPTIONS.find((p) => p.key === key) || PRIORITY_OPTIONS[3]; // Mặc định là Thấp
};

const loading = ref(true);
const currentPage = ref(0);
const pageSize = ref(10);
const totalElements = ref(0);
const totalPages = ref(0);

// ✨ MỚI: Cấu hình cột chi tiết hơn (thêm width)
const FIELD_DEFS = [
  { key: "tieuDe", label: "Tên công việc", width: "35%" },
  { key: "nguoiTao.hoTen", label: "Người tạo" },
  { key: "assignedUsers", label: "Người thực hiện" },
  { key: "ngayHoanThanh", label: "Ngày hoàn thành" },
  { key: "doUuTien", label: "Độ ưu tiên" },
  { key: "doKho", label: "Độ khó" },
  { key: "tags", label: "Thẻ Tag" },
  { key: "ngayTao", label: "Ngày tạo" },
];

const DEFAULT_FIELDS = [
  "tieuDe",
  "nguoiTao.hoTen",
  "assignedUsers",
  "ngayHoanThanh",
  "doUuTien",
  "doKho",
  "tags",
];
const LS_KEY = "archived_tasks.selectedFields.table";
const selectedFieldList = ref(
  JSON.parse(localStorage.getItem(LS_KEY)) || DEFAULT_FIELDS
);
const VISIBLE_COLS = computed(() =>
  FIELD_DEFS.filter((f) => selectedFieldList.value.includes(f.key))
);

// --- WATCHERS ---
watch(selectedCreator, (newUser) => {
  filters.creatorId = newUser ? newUser.idNguoiDung : null;
});
watch(selectedAssignedUser, (newUser) => {
  filters.assignedUserId = newUser ? newUser.idNguoiDung : null;
});
watch(
  () => filters.workspaceId,
  (newId) => {
    columns.value = [];
    filters.columnId = null;
    if (newId) fetchColumnsForWorkspace(newId);
  }
);
watch(
  selectedFieldList,
  (val) => {
    localStorage.setItem(LS_KEY, JSON.stringify(val));
  },
  { deep: true }
);

// --- METHODS ---
const openDetailModal = (task) => {
  selectedTask.value = task;
  isDetailModalVisible.value = true;
};
const closeDetailModal = () => {
  isDetailModalVisible.value = false;
};

const resetFilters = () => {
  Object.keys(filters).forEach((key) => (filters[key] = null));
  filters.tieuDe = "";
  filters.doKho = null;
  filters.tags = "";
  selectedCreator.value = null;
  selectedAssignedUser.value = null;
  applyFilter();
};

const getValue = (obj, path) => {
  const value = path.split(".").reduce((acc, part) => acc && acc[part], obj);
  if (typeof value === "string" && value.match(/^\d{4}-\d{2}-\d{2}T/)) {
    return new Date(value).toLocaleString("vi-VN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  return value ?? "-"; // Trả về '-' thay vì 'N/A' cho gọn
};

// --- API CALLS ---
const fetchInitData = async () => {
  try {
    await Promise.all([fetchWorkspaces(), fetchUsers(), fetchArchivedTasks()]);
  } catch (error) {
    console.error("Error initializing page data:", error);
  }
};

const fetchWorkspaces = async () => {
  try {
    const res = await workspaceService.getAll();
    workspaces.value = res.data;
  } catch {
    toast.error("Không thể tải danh sách không gian làm việc.");
  }
};

const fetchColumnsForWorkspace = async (workspaceId) => {
  try {
    const res = await workColumnService.getAllByWorkspaceId(workspaceId);
    columns.value = res.data;
  } catch {
    columns.value = []; // Reset nếu lỗi
    toast.error("Không thể tải danh sách cột.");
  }
};

const fetchUsers = async () => {
  try {
    const res = await userService.getAll();
    users.value = res.data.map((u) => ({
      idNguoiDung: u.idNguoiDung,
      hoTen: u.hoTen,
      avatarUrl: u.avatarUrl,
    }));
  } catch {
    toast.error("Không thể tải danh sách người dùng.");
  }
};

const fetchArchivedTasks = async () => {
  loading.value = true;
  try {
    const params = {
      page: currentPage.value,
      size: pageSize.value,
      sort: "ngayHoanThanh,desc",
      ...filters,
    };
    const cleanParams = Object.fromEntries(
      Object.entries(params).filter(([_, v]) => v != null && v !== "")
    );

    const res = await taskService.getArchived(cleanParams);
    archivedTasks.value = res.data.content;
    totalElements.value = res.data.totalElements;
    totalPages.value = res.data.totalPages;
  } catch (error) {
    toast.error(
      error?.response?.data?.message || "Không thể tải danh sách công việc."
    );
  } finally {
    loading.value = false;
  }
};

const applyFilter = () => {
  currentPage.value = 0;
  fetchArchivedTasks();
};

const goToPage = (page) => {
  if (page >= 0 && page < totalPages.value) {
    currentPage.value = page;
    fetchArchivedTasks();
  }
};

// ✨ MỚI: Xử lý hành động khôi phục và xóa
const handleRestoreTask = async (taskId) => {
  const result = await Swal.fire({
    title: "Khôi phục công việc?",
    text: "Công việc này sẽ được chuyển về trạng thái ban đầu.",
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Đồng ý!",
    cancelButtonText: "Hủy bỏ",
  });
  if (result.isConfirmed) {
    try {
      await taskService.unarchive(taskId);
      toast.success("Khôi phục công việc thành công!");
      fetchArchivedTasks(); // Tải lại danh sách
    } catch (error) {
      toast.error("Có lỗi xảy ra khi khôi phục.");
    }
  }
};

const handleDeleteTask = async (taskId) => {
  const result = await Swal.fire({
    title: "Bạn chắc chắn muốn xóa?",
    html: "Hành động này sẽ <strong>xóa vĩnh viễn</strong> công việc và không thể hoàn tác. <br/>Bạn có muốn tiếp tục?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Xóa vĩnh viễn!",
    cancelButtonText: "Hủy bỏ",
  });
  if (result.isConfirmed) {
    try {
      await taskService.delete(taskId);
      toast.success("Đã xóa công việc vĩnh viễn.");
      fetchArchivedTasks();
    } catch (error) {
      toast.error("Có lỗi xảy ra khi xóa công việc.");
    }
  }
};

// ✨ MỚI: Logic hiển thị số trang cho pagination
const visiblePages = computed(() => {
  const pages = [];
  const maxVisible = 5;
  if (totalPages.value <= maxVisible + 2) {
    for (let i = 1; i <= totalPages.value; i++) pages.push(i);
  } else {
    pages.push(1);
    const current = currentPage.value + 1;
    let start = Math.max(2, current - Math.floor((maxVisible - 2) / 2));
    let end = Math.min(totalPages.value - 1, start + maxVisible - 3);
    start = Math.max(2, end - maxVisible + 3);

    if (start > 2) pages.push("...");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages.value - 1) pages.push("...");
    pages.push(totalPages.value);
  }
  return pages;
});

onMounted(fetchInitData);
</script>
<!-- </script> -->

<style scoped>
/* Filter Card Styles */
.filter-card-header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1.25rem;
}
.filter-card-header .collapse-icon {
  transition: transform 0.3s ease;
}
.filter-card-header[aria-expanded="false"] .collapse-icon {
  transform: rotate(-90deg);
}
.filter-card .form-group label {
  font-weight: 500;
  font-size: 0.875rem;
  color: #555;
}

/* Table Enhancements */
.table thead th {
  background-color: #f8f9fa;
  white-space: nowrap;
  font-weight: 600;
}
.table-vcenter td,
.table-vcenter th {
  vertical-align: middle;
}

/* Avatar Stack */
.avatar-stack {
  display: flex;
}
.avatar-stack .avatar {
  margin-left: -10px;
  border: 2px solid #fff;
  transition: transform 0.2s;
}
.avatar-stack .avatar:hover {
  transform: translateY(-2px);
  z-index: 1;
}
.avatar-stack .avatar:first-child {
  margin-left: 0;
}
.avatar-more {
  background-color: #e9ecef;
  color: #495057;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 600;
}
.avatar-xs {
  width: 28px;
  height: 28px;
}

/* ✨ MỚI: Soft Badges for Priority */
.badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.4em 0.7em;
}
.badge-danger-soft {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}
.badge-warning-soft {
  background-color: rgba(255, 193, 7, 0.15);
  color: #c69500;
}
.badge-primary-soft {
  background-color: rgba(0, 123, 255, 0.1);
  color: #007bff;
}
.badge-secondary-soft {
  background-color: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

/* vue-multiselect custom style */
:deep(.multiselect__tags) {
  border-radius: 0.25rem;
  border: 1px solid #ced4da;
}
</style>
